import React, { useEffect, useState } from 'react';
import { FormHelperText, Slider } from '@mui/material';
import IconPopup from '../help-icon-popup';

export default ({
  label = '', range = [], onChange = null, showValue = false, disabled = false,
  options = [], value, inputFn, outputFn, info, error = '', helpText = '', instantChange = true, ...props
}) => {
  const [min = 0, max = 100] = range;
  const [localValue, setValue] = useState(value || min);

  useEffect(() => {
    let currentValue = value;
    if (currentValue === undefined) {
      currentValue = min;
    }
    if (inputFn && currentValue) currentValue = inputFn(currentValue);

    setValue(currentValue);
    // eslint-disable-next-line
  }, [value]);

  const onLocalBlur = (input) => (event, newValue) => {
    if (input === 'slider' && newValue === localValue) return;
    if (onChange) {
      let output = newValue;
      if (Number.isNaN(output)) return;
      if (output < min) output = min;
      if (output > max) output = max;
      if (outputFn) output = outputFn(output);
      setValue(output);
      onChange(output);
    }
  };

  const onLocalChange = (event) => {
    const currentValue = parseInt(event.target.value, 10) || '';
    setValue(currentValue);

    if (instantChange) {
      onLocalBlur()(event, currentValue);
    }
  };

  const infoAndError = [
    !!error && <FormHelperText key={1}><span className="block color-danger font-13 m-t-4- m-b-12">{error}</span></FormHelperText>,
    (!!helpText && !error) && (
      <FormHelperText key={2} style={{ marginLeft: 0 }}>
        {helpText}
        { info && <IconPopup content={info} /> }
      </FormHelperText>
    ),
  ];

  const rawSlider = () => (
    <div className="sliderContainer">
      <div className={`slider ${error ? 'border-danger' : '' }`} {...props}>
        <span className="slider-label">{label}</span>
        <Slider
          value={localValue || min}
          onChange={onLocalBlur('slider')}
          valueLabelDisplay="auto"
          aria-labelledby="range-slider"
          max={max}
          min={min}
          disabled={disabled}
        />
        {showValue && (
          <input
            type="number"
            className="slider-value"
            value={localValue}
            min={min}
            max={max}
            onChange={onLocalChange}
            onBlur={!instantChange ? (e) => onLocalBlur()(null, parseInt(e.target.value, 10)) : undefined}
          />
        )}
      </div>
      {
        !options.length && infoAndError
      }
    </div>
  );

  if (!options.length) return (<div className="sliderContainer">{ rawSlider() }</div>);
  return (
    <div className="sliderContainer">
      <div className={`slider ${error ? 'border-danger' : '' }`} {...props} style={{ flexFlow: 'column' }}>
        {rawSlider()}
        {
          options.length > 0 && (
            <div className="sliderOptions">
              {options.map((item, index) => (
                <div key={index} className={`option${item === value ? ' active' : ''}`} onClick={() => onLocalBlur()(null, item)}>{item}</div>
              ))}
            </div>
          )
        }
      </div>
      {
        infoAndError
      }
    </div>
  );
};
